import { useState } from 'react'

import { getAPIClient } from 'api/axios'

import { Coupon } from '../types/coupon'
import { couponErrorMessage } from './couponErrorMessage'

interface UseUnpauseCouponReturn {
  unpauseCoupon: (uuid: string) => Promise<Coupon | null>
  loading: boolean
  error: string | null
}

export const useUnpauseCoupon = (): UseUnpauseCouponReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const client = getAPIClient()

  const unpauseCoupon = async (uuid: string): Promise<Coupon | null> => {
    setLoading(true)
    setError(null)

    try {
      const response = await client.post(`/v1/coupons/${uuid}/unpause`)
      return response.data.record ?? response.data.coupon
    } catch (err: any) {
      const message = couponErrorMessage(err, 'Erro ao despausar cupom')
      setError(message)
      throw message
    } finally {
      setLoading(false)
    }
  }

  return { unpauseCoupon, loading, error }
}
